import React from "react";
// import ChartTitle from "../base/ChartTitle";
import Chains from "../chains/Chains";

import WhyChoose from "./WhyChoose";
import "./Home.css";

class Home extends React.Component {
  render() {
    return <React.Fragment>
        {this.getHeader()}
        <Chains />
        <br/>
        <p>** Expected returns is a just-in-time stat and does not consider future change in staking returns based on higher/lower total stake,
           or change in network parameters, or reflect token price changes over time. For all practical purposes, assume that the realized staking 
           returns over a long term will be lower than current numbers.</p>
        <br/>
        <WhyChoose />
    </React.Fragment>;
  }

  getHeader() {
    return <React.Fragment>
        <div className="homeMain">Transparent, professional, and feature rich Validator</div>
        <div className="homeDetails">Your analytics hub for assessing Validators, Network, Relayers, & Decentralization metrics.</div>
        <p/>
    </React.Fragment>
  }
}

export default Home;
